import React from 'react';
import { Box } from '@mui/material';
import { DOCUMENT } from '../constants/documentTheme';
import { getInquirySubject, INQUIRY_SUBJECT_LABEL_KEYS } from '../utils/partnerListUtils';

const InquirySubjectTag = ({ inquiry, t }) => {
  const subject = getInquirySubject(inquiry);
  const color = subject === 'private'
    ? DOCUMENT.oxblood
    : subject === 'package'
      ? DOCUMENT.accent
      : DOCUMENT.ink2;
  return (
    <Box
      component="span"
      data-testid="inquiry-subject-tag"
      data-subject={subject}
      sx={{
        display: 'inline-block',
        px: 0.75,
        py: '1px',
        border: `1px solid ${color}`,
        color,
        fontSize: 9.5,
        lineHeight: 1.5,
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
      }}
    >
      {t(INQUIRY_SUBJECT_LABEL_KEYS[subject])}
    </Box>
  );
};

export default InquirySubjectTag;
